import styled from "styled-components";
import { TEXT_SECONDARY } from "@streeteasy/design-system/colors";
import TextLink from "@streeteasy/design-system/deprecated/actions/text-link";
import { Caption, PrimaryMedium } from "@streeteasy/design-system/typography";

import { smallScreen } from "src/shared/constants/screenSizes";

export const ListingAgentMatchContainer = styled.div`
  margin: 0 auto;
  max-width: 1404px;
  padding: 26px 48px 24px;

  @media screen and (max-width: ${smallScreen}px) {
    padding: 40px 24px 24px;
  }
`;

export const Title = styled(PrimaryMedium)`
  padding-bottom: 16px;

  @media screen and (max-width: ${smallScreen}px) {
    padding-bottom: 24px;
  }
`;

export const Copy = styled.p`
  margin: 10px 0 0;
`;

export const Link = styled(TextLink)`
  @media screen and (max-width: ${smallScreen}px) {
    display: inline-block;
  }
`;

export const CaptionText = styled(Caption)`
  color: ${TEXT_SECONDARY};
  margin: 20px auto 0;
  max-width: 613px;
  text-align: center;

  @media screen and (max-width: ${smallScreen}px) {
    text-align: left;
  }
`;
